import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../../styles/chat/NavbarTop.css';
import Logo from './../../components/logo.png'
import LogoMobile from './../../components/logo-mobile.png'
import * as globals from './../../components/GlobalScripts.js';

const NavbarTop = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const location = useLocation();
    const [user, setUser] = useState([]);
    const [isMenuOpen, setMenuIsOpen] = useState(false);
    const [conversationsNoRead, setConversationsNoRead] = useState(0);

    useEffect(() => {
        if (globals.isAuthenticated()) {
            globals.validateSession();
        }

        get_conversations_no_read();

        const intervalId = setInterval(() => {
            get_conversations_no_read();
        }, 10000);

        return () => clearInterval(intervalId);
    }, [location]);


    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            setUser(JSON.parse(user_cache));
        }
    }, []);

    const toggleMenuDropdown = () => {
        setMenuIsOpen(!isMenuOpen);
    };

    const handleLogout = async () => {
        localStorage.removeItem('session_id');
        localStorage.removeItem('keylogin');
        localStorage.removeItem('code_confirm');
        localStorage.removeItem('user');

        localStorage.removeItem('formDataSearch');
        navigate(`/login`);
    };

    const get_conversations_no_read = () => {
        axios.post(`${path_api}/chat/get_conversations_no_read.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                if (response.data.conversations > 99)
                    setConversationsNoRead(99);
                else
                    setConversationsNoRead(response.data.conversations);
            }
        }).catch(err => {
            console.error(err);
        });
    };

    return (
        <>
            <nav className="navbar-top">
                <div className="navs">
                    <div className="primary-nav">
                        <div>
                            <Link to="/">
                                <img className='logo' src={Logo} alt='Logo' />
                            </Link>
                            <Link to="/" className="button-primary transparent">Inicio</Link>
                            {globals.isAuthenticated() && user?.rol == 1 && (
                                <Link to="/cliente" className="button-primary transparent">Mi perfil</Link>
                            )}
                            {globals.isAuthenticated() && user?.rol == 2 && (
                                <Link to="/profesional" className="button-primary transparent">Mi perfil</Link>
                            )}
                            {globals.isAuthenticated() && user?.rol == 4 && (
                                <Link to="/admin/cuentas" className="button-primary transparent">Administrar</Link>
                            )}
                            <Link to="/chat/view" className="button-primary transparent">
                                Conversaciones
                                {conversationsNoRead > 0 && (
                                    <span className="conversations-news">{conversationsNoRead}</span>
                                )}
                            </Link>
                        </div>
                        <div>
                            <div className="container-profile-navbar">
                                <img src={path_api + (user?.img_profile != "/images/profile_default.png" ? user?.account?.img_profile : user?.img_profile)} />
                                <p>{user?.nombre}</p>
                            </div>
                            <button onClick={handleLogout} className="button-primary">Cerrar sesión</button>
                        </div>
                    </div>

                    <div className="primary-nav-mobile">
                        <div>
                            <Link to="/">
                                <img className='logo square' src={LogoMobile} alt='Logo' />
                            </Link>
                        </div>
                        <div>
                            {(!globals.isAuthenticated() || (globals.isAuthenticated() && user?.rol == 1)) && (
                                <Link to="/solicitar" className="button-primary white">Solicitar</Link>
                            )}
                            <button onClick={toggleMenuDropdown} className="container-icon cursor-pointer">
                                {!isMenuOpen ? (
                                    <svg viewBox="0 0 33 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1H23" stroke="#1D58A1" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M10 13H32" stroke="#1D58A1" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                ) : (
                                    <svg viewBox="0 0 34 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L33 20" stroke="#1D58A1" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M1.5 20L33 1" stroke="#1D58A1" strokeWidth="2" strokeLinecap="round" />
                                    </svg>

                                )}
                            </button>
                        </div>
                    </div>

                    {isMenuOpen && (
                        <div className="secundary-nav">
                            <div>
                                <Link to="/" className="button-primary transparent" onClick={toggleMenuDropdown}>Inicio</Link>
                                {globals.isAuthenticated() && user?.rol == 1 && (
                                    <Link to="/cliente" className="button-primary transparent" onClick={toggleMenuDropdown}>Mi perfil</Link>
                                )}
                                {globals.isAuthenticated() && user?.rol == 2 && (
                                    <Link to="/profesional" className="button-primary transparent" onClick={toggleMenuDropdown}>Mi perfil</Link>
                                )}
                                {globals.isAuthenticated() && user?.rol == 4 && (
                                    <Link to="/admin/cuentas" className="button-primary transparent" onClick={toggleMenuDropdown}>Administrar</Link>
                                )}
                                <Link to="/chat/view" className="flex-row gap-20 button-primary transparent" onClick={toggleMenuDropdown}>
                                    Conversaciones
                                    {conversationsNoRead > 0 && (
                                        <span className="conversations-news">{conversationsNoRead}</span>
                                    )}
                                </Link>
                                <button onClick={handleLogout} className="button-primary normal">Cerrar sesión</button>
                            </div>
                        </div>
                    )}
                </div>
            </nav>
        </>
    );
};

export default NavbarTop;